"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHSGT = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var mini_k_chart_1 = require("./shared/mini_k_chart");
var title_bar_1 = require("./shared/title_bar");
var zixun_1 = require("./shared/zixun");
var title_1 = require("./shared/title");
var title_quotetable_1 = require("./shared/title/title_quotetable");
var quote_1 = require("../../modules/quote");
var config_1 = require("../../modules/quote/config");
var hsgt_1 = require("../../modules/quote/hsgt");
var middle_1 = require("../quotetable/middle");
require("./hsgt.less");
/**
 * 沪深港通页面
 */
function PageHSGT() {
    return (react_1.default.createElement("div", { className: "pagehsgt" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(ChartItem, { code: "1.000001", txt: "\u4E0A\u8BC1\u6307\u6570" }),
            react_1.default.createElement(ChartItem, { code: "0.399001", txt: "\u6DF1\u6210\u6307\u6570" }),
            react_1.default.createElement(ChartItem, { code: "0.399006", txt: "\u521B\u4E1A\u6307\u6570" }),
            react_1.default.createElement(ChartItem, { code: "100.HSI", txt: "\u6052\u751F\u6307\u6570" })),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 15 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "//hk.eastmoney.com/a/cggdd.html" }, "\u6E2F\u80A1\u5BFC\u8BFB")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.ColumnNewsScroll, { columns: "797" }))),
        react_1.default.createElement(title_1.Title1, { mt: 10 },
            react_1.default.createElement(title_1.Title1.Main, null,
                react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u8D44\u91D1\u6D41\u5411"))),
        react_1.default.createElement(HSGTTable, null),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(HSGTChildTable, { tit: "\u6CAA\u80A1\u901A(\u6E2F>\u6CAA)", link: "gridlist.html#sh_hk_board", fs: "b:BK0707", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6CAA\u80A1\u901A\u80A1\u7968" })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(HSGTChildTable, { tit: "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)", link: "gridlist.html#sz_hk_board", fs: "b:BK0804", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6DF1\u80A1\u901A\u80A1\u7968" }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(HSGTChildTable, { tit: "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)", link: "gridlist.html#hk_sh_stocks", fs: "b:MK0144", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)\u80A1\u7968" })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(HSGTChildTable, { tit: "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)", link: "gridlist.html#hk_sz_stocks", fs: "b:MK0146", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)\u80A1\u7968" }))),
        react_1.default.createElement(title_1.Title1, { mt: 10 },
            react_1.default.createElement(title_1.Title1.Main, null,
                react_1.default.createElement("a", { href: "./gridlist.html#ah_comparison" }, "A+H\u80A1\u6BD4\u4EF7"))),
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: 'b:MK0101',
            count: 5,
            table_key: 'AHTable',
            order: 'f3',
            orderdur: 1 }),
        react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
            react_1.default.createElement("a", { href: "./gridlist.html#ah_comparison", target: "_blank" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8A+H\u80A1\u6BD4\u4EF7>>"))));
}
exports.PageHSGT = PageHSGT;
/**
 * chart 四分卫子元素
 * @param props
 * @returns
 */
function ChartItem(props) {
    return (react_1.default.createElement(layout_1.Layout4.Item, null,
        react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: props.code, height: 193, link: true, border: false }, props.txt),
        react_1.default.createElement("div", { style: { marginTop: 15 } },
            react_1.default.createElement(mini_k_chart_1.MiniKChart, { quotecode: props.code }))));
}
/**
 * layout2 子元素table
 * @param props
 * @returns
 */
function HSGTChildTable(props) {
    return (react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: props.link },
            props.bmtxt,
            ">>"), table_key: 'HSGTTABLE',
        fs: props.fs,
        count: 5,
        order: 'f3',
        orderdur: 1,
        tagclass: '' },
        react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.tit)));
}
/**
 * 沪深港通资金流向table
 * @returns
 */
function HSGTTable() {
    var _this = this;
    var _a = (0, react_1.useState)(null), showdata = _a[0], SetShowData = _a[1];
    /** 获取数据 */
    var gethgtInfos = function () { return __awaiter(_this, void 0, void 0, function () {
        var hsgtinfo, secids, quotes, obj;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        return __generator(this, function (_0) {
            switch (_0.label) {
                case 0: return [4 /*yield*/, (0, hsgt_1.hsgt)()];
                case 1:
                    hsgtinfo = (_0.sent()) || {};
                    secids = "90.BK0707,201.HK32,90.BK0804,201.HK31,1.000001,100.HSI,0.399001";
                    return [4 /*yield*/, (0, quote_1.getListQuoteNPList)(secids, [
                            config_1.QuoteItem.代码,
                            config_1.QuoteItem.涨跌幅,
                            config_1.QuoteItem.市场,
                            config_1.QuoteItem.板块或指数上涨数量,
                            config_1.QuoteItem.板块或指数下跌数量,
                            config_1.QuoteItem.板块或指数平数量
                        ])];
                case 2:
                    quotes = _0.sent();
                    obj = {
                        SH: {
                            netBuyAmt: (_a = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sh) === null || _a === void 0 ? void 0 : _a.netBuyAmt,
                            FlowSub: (_b = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sh) === null || _b === void 0 ? void 0 : _b.dayNetAmtIn,
                            DBalanceSub: (_c = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sh) === null || _c === void 0 ? void 0 : _c.dayAmtRemain,
                            DTSub: (_d = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sh) === null || _d === void 0 ? void 0 : _d.dayAmtThreshold,
                            status: ((_e = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sh) === null || _e === void 0 ? void 0 : _e.status) || "",
                            ChangePercent: quotes[4][config_1.QuoteItem.涨跌幅].html,
                            upnum: quotes[0][config_1.QuoteItem.板块或指数上涨数量].html,
                            flatnum: quotes[0][config_1.QuoteItem.板块或指数平数量].html,
                            downnum: quotes[0][config_1.QuoteItem.板块或指数下跌数量].html,
                            amtStatus: ((_f = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sh) === null || _f === void 0 ? void 0 : _f.amtStatus) || ""
                        },
                        HK_SH: {
                            netBuyAmt: (_g = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sh2hk) === null || _g === void 0 ? void 0 : _g.netBuyAmt,
                            FlowSub: (_h = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sh2hk) === null || _h === void 0 ? void 0 : _h.dayNetAmtIn,
                            DBalanceSub: (_j = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sh2hk) === null || _j === void 0 ? void 0 : _j.dayAmtRemain,
                            DTSub: (_k = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sh2hk) === null || _k === void 0 ? void 0 : _k.dayAmtThreshold,
                            status: ((_l = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sh2hk) === null || _l === void 0 ? void 0 : _l.status) || "",
                            ChangePercent: quotes[5][config_1.QuoteItem.涨跌幅].html,
                            upnum: quotes[1][config_1.QuoteItem.板块或指数上涨数量].html,
                            flatnum: quotes[1][config_1.QuoteItem.板块或指数平数量].html,
                            downnum: quotes[1][config_1.QuoteItem.板块或指数下跌数量].html,
                            amtStatus: ((_m = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sh2hk) === null || _m === void 0 ? void 0 : _m.amtStatus) || ""
                        },
                        SZ: {
                            netBuyAmt: (_o = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sz) === null || _o === void 0 ? void 0 : _o.netBuyAmt,
                            FlowSub: (_p = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sz) === null || _p === void 0 ? void 0 : _p.dayNetAmtIn,
                            DBalanceSub: (_q = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sz) === null || _q === void 0 ? void 0 : _q.dayAmtRemain,
                            DTSub: (_r = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sz) === null || _r === void 0 ? void 0 : _r.dayAmtThreshold,
                            status: ((_s = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sz) === null || _s === void 0 ? void 0 : _s.status) || "",
                            ChangePercent: quotes[6][config_1.QuoteItem.涨跌幅].html,
                            upnum: quotes[2][config_1.QuoteItem.板块或指数上涨数量].html,
                            flatnum: quotes[2][config_1.QuoteItem.板块或指数平数量].html,
                            downnum: quotes[2][config_1.QuoteItem.板块或指数下跌数量].html,
                            amtStatus: ((_t = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.hk2sz) === null || _t === void 0 ? void 0 : _t.amtStatus) || ""
                        },
                        HK_SZ: {
                            netBuyAmt: (_u = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sz2hk) === null || _u === void 0 ? void 0 : _u.netBuyAmt,
                            FlowSub: (_v = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sz2hk) === null || _v === void 0 ? void 0 : _v.dayNetAmtIn,
                            DBalanceSub: (_w = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sz2hk) === null || _w === void 0 ? void 0 : _w.dayAmtRemain,
                            DTSub: (_x = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sz2hk) === null || _x === void 0 ? void 0 : _x.dayAmtThreshold,
                            status: ((_y = hsgtinfo.sz2hk) === null || _y === void 0 ? void 0 : _y.status) || "",
                            ChangePercent: quotes[5][config_1.QuoteItem.涨跌幅].html,
                            upnum: quotes[3][config_1.QuoteItem.板块或指数上涨数量].html,
                            flatnum: quotes[3][config_1.QuoteItem.板块或指数平数量].html,
                            downnum: quotes[3][config_1.QuoteItem.板块或指数下跌数量].html,
                            amtStatus: ((_z = hsgtinfo === null || hsgtinfo === void 0 ? void 0 : hsgtinfo.sz2hk) === null || _z === void 0 ? void 0 : _z.amtStatus) || ""
                        }
                    };
                    // obj.SH.status = 4
                    // obj.HK_SH.status = 4
                    // obj.SZ.status = 4
                    // obj.HK_SZ.status = 4
                    SetShowData(obj);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        gethgtInfos();
        var cd = setInterval(function () {
            gethgtInfos();
        }, 60 * 1000);
        return function () {
            try {
                clearInterval(cd);
            }
            catch (error) {
            }
        };
    }, []);
    if (!showdata)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "hsgttable" },
        react_1.default.createElement("table", { className: "quotetable_m" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "\u7C7B\u578B"),
                    react_1.default.createElement("th", { title: "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)\u4EE3\u8868\u6CAA\u6E2F\u901A\u7684\u6E2F\u80A1\u901A\u90E8\u5206\uFF0C\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)\u4EE3\u8868\u6DF1\u6E2F\u901A\u7684\u6E2F\u80A1\u901A\u90E8\u5206\u3002" },
                        "\u677F\u5757",
                        react_1.default.createElement("em", { className: "icon_qa" })),
                    react_1.default.createElement("th", null, "\u677F\u5757\u6DA8\u8DCC\u5E45"),
                    react_1.default.createElement("th", { title: "\u9999\u6E2F\u6295\u8D44\u8005\u4EA4\u6613\u5185\u5730\u80A1\u7968\uFF0C\u79F0\u4E3A\u5317\u5411\u8D44\u91D1\uFF0C\u5185\u5730\u6295\u8D44\u8005\u4EA4\u6613\u9999\u6E2F\u80A1\u7968\uFF0C\u79F0\u4E3A\u5357\u5411\u8D44\u91D1\u3002" },
                        "\u8D44\u91D1\u65B9\u5411",
                        react_1.default.createElement("em", { className: "icon_qa" })),
                    react_1.default.createElement("th", null, "\u4EA4\u6613\u72B6\u6001"),
                    react_1.default.createElement("th", { title: "\u5F53\u65E5\u6210\u4EA4\u51C0\u4E70\u989D = \u4E70\u5165\u6210\u4EA4\u989D - \u5356\u51FA\u6210\u4EA4\u989D" },
                        "\u6210\u4EA4\u51C0\u4E70\u989D",
                        react_1.default.createElement("em", { className: "icon_qa" })),
                    react_1.default.createElement("th", { title: "\u6839\u636E\u4EA4\u6613\u6240\u89C4\u5B9A\uFF0C\u5F53\u65E5\u8D44\u91D1\u4F59\u989D\u5927\u4E8E\u6216\u7B49\u4E8E30%\u65F6\uFF0C\u663E\u793A\u201C\u989D\u5EA6\u5145\u8DB3\u201D\uFF1B\u5C0F\u4E8E30%\u65F6\uFF0C\u5B9E\u65F6\u516C\u5E03\u8D44\u91D1\u4F59\u989D\u3002" },
                        "\u5F53\u65E5\u8D44\u91D1\u4F59\u989D",
                        react_1.default.createElement("em", { className: "icon_qa" })),
                    react_1.default.createElement("th", null, "\u5F53\u65E5\u8D44\u91D1\u9650\u989D"),
                    react_1.default.createElement("th", null, "\u4E0A\u6DA8\u6570"),
                    react_1.default.createElement("th", null, "\u6301\u5E73\u6570"),
                    react_1.default.createElement("th", null, "\u4E0B\u8DCC\u6570"),
                    react_1.default.createElement("th", null, "\u76F8\u5173\u6307\u6570"))),
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { rowSpan: 2, className: "bBottom" }, "\u6CAA\u6E2F\u901A"),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "gridlist.html#sh_hk_board", target: "_blank" }, "\u6CAA\u80A1\u901A(\u6E2F>\u6CAA)")),
                    react_1.default.createElement("td", null, showdata.SH.ChangePercent),
                    react_1.default.createElement("td", null, "\u5317\u5411"),
                    react_1.default.createElement("td", null, getStockStatus(showdata.SH.status)),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(JME, { status: showdata.SH.status, netBuyAmt: showdata.SH.netBuyAmt })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(BX_ZJ_ZJYE, { DBalanceSub: showdata.SH.DBalanceSub, dayAmtRemain: showdata.SH.dayAmtRemain, status: showdata.SH.status, amtStatus: showdata.SH.amtStatus })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(FormatZJNum, { money: showdata.SH.DTSub, color: false })),
                    react_1.default.createElement("td", null, showdata.SH.upnum),
                    react_1.default.createElement("td", null, showdata.SH.flatnum),
                    react_1.default.createElement("td", null, showdata.SH.downnum),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/zs000001.html", target: "_blank" }, "\u4E0A\u8BC1\u6307\u6570"))),
                react_1.default.createElement("tr", { className: " bBottom" },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "gridlist.html#hk_sh_stocks", target: "_blank" }, "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)")),
                    react_1.default.createElement("td", null, showdata.HK_SH.ChangePercent),
                    react_1.default.createElement("td", null, "\u5357\u5411"),
                    react_1.default.createElement("td", null, getStockStatus(showdata.HK_SH.status)),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(JME, { status: showdata.HK_SH.status, netBuyAmt: showdata.HK_SH.netBuyAmt })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(BX_ZJ_ZJYE, { DBalanceSub: showdata.HK_SH.DBalanceSub, dayAmtRemain: showdata.HK_SH.dayAmtRemain, status: showdata.HK_SH.status, amtStatus: showdata.HK_SH.amtStatus })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(FormatZJNum, { money: showdata.HK_SH.DTSub, color: false })),
                    react_1.default.createElement("td", null, showdata.HK_SH.upnum),
                    react_1.default.createElement("td", null, showdata.HK_SH.flatnum),
                    react_1.default.createElement("td", null, showdata.HK_SH.downnum),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/gb/zsHSI.html", target: "_blank" }, "\u6052\u751F\u6307\u6570"))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { rowSpan: 2, className: "bBottom" }, "\u6DF1\u6E2F\u901A"),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "gridlist.html#sz_hk_board", target: "_blank" }, "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)")),
                    react_1.default.createElement("td", null, showdata.SZ.ChangePercent),
                    react_1.default.createElement("td", null, "\u5317\u5411"),
                    react_1.default.createElement("td", null, getStockStatus(showdata.SZ.status)),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(JME, { status: showdata.SZ.status, netBuyAmt: showdata.SZ.netBuyAmt })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(BX_ZJ_ZJYE, { DBalanceSub: showdata.SZ.DBalanceSub, dayAmtRemain: showdata.SZ.dayAmtRemain, status: showdata.SZ.status, amtStatus: showdata.SZ.amtStatus })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(FormatZJNum, { money: showdata.SZ.DTSub, color: false })),
                    react_1.default.createElement("td", null, showdata.SZ.upnum),
                    react_1.default.createElement("td", null, showdata.SZ.flatnum),
                    react_1.default.createElement("td", null, showdata.SZ.downnum),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/zs399001.html", target: "_blank" }, "\u6DF1\u6210\u6307\u6570"))),
                react_1.default.createElement("tr", { className: " bBottom" },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "gridlist.html#hk_sz_stocks", target: "_blank" }, "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)")),
                    react_1.default.createElement("td", null, showdata.HK_SZ.ChangePercent),
                    react_1.default.createElement("td", null, "\u5357\u5411"),
                    react_1.default.createElement("td", null, getStockStatus(showdata.HK_SZ.status)),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(JME, { status: showdata.HK_SZ.status, netBuyAmt: showdata.HK_SZ.netBuyAmt })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(BX_ZJ_ZJYE, { DBalanceSub: showdata.HK_SZ.DBalanceSub, dayAmtRemain: showdata.HK_SZ.dayAmtRemain, status: showdata.HK_SZ.status, amtStatus: showdata.HK_SZ.amtStatus })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(FormatZJNum, { money: showdata.HK_SZ.DTSub, color: false })),
                    react_1.default.createElement("td", null, showdata.HK_SZ.upnum),
                    react_1.default.createElement("td", null, showdata.HK_SZ.flatnum),
                    react_1.default.createElement("td", null, showdata.HK_SZ.downnum),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/gb/zsHSI.html", target: "_blank" }, "\u6052\u751F\u6307\u6570")))))));
}
/**
 * 当日资金余额
 */
function BX_ZJ_ZJYE(props) {
    if (props.amtStatus == 1) {
        return react_1.default.createElement(react_1.default.Fragment, null, "\u989D\u5EA6\u5145\u8DB3");
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FormatZJNum, { money: props.DBalanceSub, color: false }));
}
/**
 * 成交净买额
 */
function JME(props) {
    if (props.status == 4) {
        return react_1.default.createElement(react_1.default.Fragment, null, "-");
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FormatZJNum, { money: props.netBuyAmt, color: true }));
}
function FormatZJNum(props) {
    var money = props.money;
    var showcolor = props.color;
    if (isNaN(money) || money === '') {
        return react_1.default.createElement(react_1.default.Fragment, null, money);
    }
    if (money == 0) {
        return react_1.default.createElement(react_1.default.Fragment, null, "-");
    }
    money = money * 10000;
    var hz = '';
    if (money >= 100000000 || money <= -100000000) {
        money = money / 100000000;
        hz = '亿';
    }
    else if (money >= 10000 || money <= -10000) {
        money = money / 10000;
        hz = '万';
    }
    var number_class = '';
    if (showcolor) {
        if (money > 0) {
            number_class = 'price_up';
        }
        else if (money < 0) {
            number_class = 'price_down';
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: " ".concat(number_class) },
            money.toFixed(2),
            hz)));
}
/**
 * 板块状态
 * @param code
 * @returns
 */
function getStockStatus(code) {
    var status = parseInt(code);
    switch (status) {
        case 1:
            return "额度可用";
        case 2:
            return "额度已满";
        case 3:
        case 3:
            return "收盘";
        case 4:
            return "休市";
        default:
            return "-";
    }
}
;
/**
 * AH比价
 */
// function AHBJTable() {
//   let quoteitemlist = [
//     QuoteItem.市场,
//     QuoteItem.H股对应的A股市场,
//     QuoteItem.H股对应的A股行情统一链接,
//     QuoteItem.代码,
//     QuoteItem.最新价,
//     QuoteItem.涨跌幅,
//     QuoteItem.H股对应的A股代码,
//     QuoteItem.H股对应的A股最新价,
//     QuoteItem.H股对应的A股涨跌幅,
//     QuoteItem.AH股比价,
//     QuoteItem.AH股溢价
//   ]
//   const { data, error } = useSWR(`quotesmalltable_ahbj`, async () => {
//     return await searchListQuote('b:MK0101', quoteitemlist, 'f3', 1, 5)
//   }, {
//     refreshInterval: 60 * 1000
//   })
//   if (!data) return <></>
//   return (<div className="ahtable">
//     <table className="quotetable_m">
//       <thead>
//         <tr>
//           <th>序号</th>
//           <th>名称</th>
//           <th>H股代码</th>
//           <th>最新价(HKD)</th>
//           <th>涨跌幅</th>
//           <th>港股吧</th>
//           <th>A股代码</th>
//           <th>最新价(RMB)</th>
//           <th>涨跌幅</th>
//           <th>A股吧</th>
//           <th>比价（A/H）</th>
//           <th>溢价（A/H）%</th>
//           <th>加自选</th>
//         </tr>
//       </thead>
//       <tbody>
//         {
//           data && data.map((v: any, i: number) => {
//             return <tr key={i}>
//               <td>{i + 1}</td>
//               <td>{v[QuoteItem.H股对应的A股行情统一链接].html}</td>
//               <td>{v[QuoteItem.代码].html}</td>
//               <td>{v[QuoteItem.最新价].html}</td>
//               <td>{v[QuoteItem.涨跌幅].html}</td>
//               <td><a href={`http://guba.eastmoney.com/list,hk${v[QuoteItem.代码].txt}.html`}>港股吧</a></td>
//               <td>{v[QuoteItem.H股对应的A股代码].html}</td>
//               <td>{v[QuoteItem.H股对应的A股最新价].html}</td>
//               <td>{v[QuoteItem.H股对应的A股涨跌幅].html}</td>
//               <td><a href={`http://guba.eastmoney.com/topic,${v[QuoteItem.H股对应的A股代码].txt}.html`}>A股吧</a></td>
//               <td>{v[QuoteItem.AH股比价].html}</td>
//               <td>{v[QuoteItem.AH股溢价].html}</td>
//               <td><AddZXGBtn quotecode={""}></AddZXGBtn></td>
//             </tr>
//           })
//         }
//       </tbody>
//     </table>
//   </div>)
// }
